module.exports = ":host .view-wrapper {\n  position: relative;\n  z-index: 0;\n  padding: 90px 0 0 0;\n  margin: 0; }\n"